module.exports = __webpack_public_path__ + "img/diesel-locomotive-shadow-06.b47d0aa6.png";